<template>
    <tr>
        <td>
            {{$date.format(new Date(item.data))}}
        </td>
        <td>
            {{item.nomeAparelho}}
        </td>

        <td>
            {{item.email}} <br/> {{item.telefone}}
        </td>

        <td>
            {{$date.format(new Date(item.dataNascimento))}} <br/> {{item.sexo}}
        </td>

        <td>
            {{item.ipLocal}} <br/> {{item.macAddress}}
        </td>

        <td>
            {{liberacao}}
        </td>


    </tr>
</template>

<script>
    import tableItem from '@mixins/table-item'
    export default {
        components: {
        },

        data() {
            return {
                entity: 'promocionalcode'
            }
        },
        methods: {
        },

        computed:{
            liberacao() {
                return this.item.dataLiberacao ? 'Sim' : 'Não';
            }
        },

        mixins: [tableItem]
    }
</script>

<style lang="scss" scoped>
    @import "~@variables";

    .edit {

        .mdi {
            font-size: 18px;

            &:not(:last-child) {
                margin-right: 6px;
            }
        }
    }
</style>
